import { defineStore } from 'pinia'
import language from '@/model/text.json'

export const useStore = defineStore('store', {
    state: () => ({
        lang: 'en'
    }),
    persist: true,
    getters: {
        langData(state) {
            return language[state.lang] //Object.assign({}, language[state.lang], { newProp: 'value' })
        },
    },
    actions: {
        setLang(type) {
            this.lang = type
        }
    }
})